import { createVanIconComponent } from "./van"

const More = createVanIconComponent("more")
export default More
